import { Logo } from '@insight-health-ai/roseate/components';

const ErrorPage: React.FC<{
  code?: number | string;
  title?: string;
  description?: string;
}> = ({ code, title, description }) => {
  return (
    <main className="loader-wrapper flex flex-col items-center justify-center w-[100vw] h-[100vh] p-8 text-center">
      <Logo />
      {code && (
        <p className="text-base font-semibold text-indigo-600">{code}</p>
      )}
      {title && (
        <h1 className="mt-4 text-xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          {title}
        </h1>
      )}
      {description && (
        <p className="mt-6 text-base leading-7 text-gray-600">{description}</p>
      )}
    </main>
  );
};

export { ErrorPage };
